import clsx from 'clsx'
import { navbarRoutes } from 'src/routes'
import NavBarLink from './NavBarLink'

export interface NavBarProps {
  className?: string
}

const NavBarDesktop: React.FC<NavBarProps> = ({ className }) => {
  return (
    <div className={clsx('flex items-center space-x-6', className)}>
      {navbarRoutes.map(({ path, name, activePaths }) => (
        <NavBarLink key={path} path={path} name={name} activePaths={activePaths} />
      ))}
    </div>
  )
}

export default NavBarDesktop
